import React, { Component } from 'react';
import { Collapse, Checkbox, List } from 'antd';

const { Panel } = Collapse;

class SegmentsBrandsSelector extends Component {
  handleSegmentCheckboxChange = (segment, checked) => {
    const { onSegmentChange } = this.props;
    onSegmentChange(segment, checked);
  }

  handleBrandCheckboxChange = (segmentId, brandId, checked) => {
    const { onBrandChange } = this.props;
    onBrandChange(segmentId, brandId, checked);
  }

  renderSegments = (segmentos, selectedItems) => {
    return (
      <Collapse bordered={true} accordion>
        {
          segmentos && segmentos.map((segment, index) => (
            <Panel header={
              <Checkbox
                data-testid={`segment-checkbox-${index}`} 
                checked={!!selectedItems[segment.id]}
                onChange={(e) => this.handleSegmentCheckboxChange(segment, e.target.checked)}
              >
                {segment.descripcion.toUpperCase()}
              </Checkbox>
            } key={segment.id}>
              {segment.brands && this.renderBrands(segment.id, segment.brands, selectedItems)}
            </Panel>
          ))
        }
      </Collapse>
    );
  }

  renderBrands = (segmentId, brands, selectedItems) => {
    return (
      <List
        size="small"
        bordered={false}
        dataSource={brands}
        renderItem={(brand, index) => (
          <List.Item key={brand.id}>
            <Checkbox
              data-testid={`brand-checkbox-${index}`}
              checked={selectedItems[segmentId] && selectedItems[segmentId].includes(brand.id)}
              onChange={(e) => this.handleBrandCheckboxChange(segmentId, brand.id, e.target.checked)}
            >
              {brand.descripcion}
            </Checkbox>
          </List.Item>
        )}
      />
    );
  }

  render() {
    const { segmentos, selectedItems } = this.props;
    return this.renderSegments(segmentos, selectedItems);
  }
}

export default SegmentsBrandsSelector;
